/* ========================================
   REALIFT / REALFOOT — Cart Tracking
   Tracks purchases from users who used the foot scanner
   ======================================== */

function addTotal(cartTotal) {
  cartTotal = cartTotal.replace(/\$/g, "");
  let hasOrderedAlready = false;
  const currentOrder = JSON.parse(localStorage.getItem("realift:realfoot:order"));
  if (currentOrder) {
    const currentDate = new Date(currentOrder.date);
    const today = new Date();
    if (today.valueOf() / 1000 - currentDate.valueOf() / 1000 < 60) {
      hasOrderedAlready = true;
    }
  }
  if (localStorage.getItem("realift:hasMeasurements") == "true" && hasOrderedAlready == false && typeof window.gtag === "function") {
    gtag("event", "realsize_add_total", {
      event_category: "RealSize",
      event_label: "RealSize Add Total",
      value: cartTotal,
      use_beacon: true,
    });
    gtag("event", "realsize_add_transaction", {
      event_category: "RealSize",
      event_label: "RealSize Add Transaction",
      value: 1,
      use_beacon: true,
    });
    localStorage.setItem("realift:realfoot:order", JSON.stringify({ date: new Date().toUTCString() }));
  }
}

/* Fire on checkout button click (cart drawer + cart page) */
document.addEventListener("click", function(e) {
  var btn = e.target.closest('[name="checkout"], .checkout-button');
  if (!btn) return;
  fetch("/cart.js")
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      addTotal("$" + cart.total_price / 100);
    })
    .catch(function() {});
});
